import { isTablet } from '../modules/functions';

export function navigation() {
  const $navigation = $('.header-navigation');
  const $footerNavigation = $('.footer-navigation');

  $navigation.find('.header-has-sub-navigation')
    .on('mouseenter', function () {
      if (isTablet()) return;

      const $t = $(this);

      clearTimeout($t.data('timeout'));

      $t.removeClass('hide').addClass('show');
    })
    .on('mouseleave', function () {
      if (isTablet()) return;

      const $t = $(this);

      $t.addClass('hide');

      const timeout = setTimeout(() => {
        $t.removeClass('show hide');
      }, 600);

      $t.data('timeout', timeout);
    });

  $navigation.find('.header-has-sub-navigation a').on('click', (e) => {
    if (!isTablet()) return;

    const $t = $(e.currentTarget);

    accordionNavigation($t, $navigation, 'header');
  });

  $footerNavigation.find('.footer-has-sub-navigation a').on('click', (e) => {
    const $t = $(e.currentTarget);

    accordionNavigation($t, $footerNavigation, 'footer');
  });
}

function accordionNavigation($el, $nav, startClass) {
  if ($el.is('.active')) {
    $el.removeClass('active');
    $el.next().slideUp(300);
  } else {
    $nav.find(`.${startClass}-has-sub-navigation a`).removeClass('active');
    $nav.find(`.${startClass}-sub-navigation`).slideUp(300);

    $el.addClass('active');
    $el.next().slideDown(300);
  }
}